import axios, { InternalAxiosRequestConfig } from 'axios';
import { isAccountSwitchTransitionPending } from '@/shared/lib/account-switch-transition';
import { useTokenStore } from '@/shared/store/token-store';

/**
 * 토큰 없이도 axiosClient로 호출 가능한 API URL 패턴
 * 공개 페이지(/payment/plan/product, /auth/help/pw 등)에서 사용되는 API
 */
const NO_AUTH_REQUIRED_URLS = [
  // BE 에서 permitAll 인 공개 region context. 랜딩·가격 페이지의 비로그인 region 분기에 쓴다.
  '/v1.0/region/context',
  '/v1.0/product/plans',
  '/v1.0/product/plan/',
  '/v1.0/product/points',
  '/v1.0/sign/reset-password',
  '/v1.0/user/coupon/available',
];

const isNoAuthRequiredUrl = (url?: string): boolean => {
  if (!url) return false;
  return NO_AUTH_REQUIRED_URLS.some(
    (pattern) => url === pattern || url.startsWith(pattern),
  );
};

/**
 * Authorization 헤더를 추가하는 인터셉터
 * - accessToken이 없고 whitelist에도 없으면 요청을 취소
 * - accessToken이 있으면 Authorization 헤더 추가
 * - switchAccessToken이 있으면 X-Switch-Authorization 헤더 추가
 */
export const attachAuthHeader = (config: InternalAxiosRequestConfig): void => {
  config.withCredentials = true;

  // 다른 탭의 START를 수신한 뒤 새 target token을 복원하기 전에는 old target이나
  // operator 자격으로 account-scoped 요청이 빠져나가지 않도록 fail closed한다.
  if (isAccountSwitchTransitionPending()) {
    throw new axios.Cancel('Account switch transition in progress');
  }

  const { accessToken, switchAccessToken } = useTokenStore.getState();

  if (!accessToken) {
    if (!isNoAuthRequiredUrl(config.url)) {
      throw new axios.Cancel('No access token');
    }
    return;
  }

  config.headers.Authorization = accessToken;
  if (switchAccessToken) {
    config.headers['X-Switch-Authorization'] = switchAccessToken;
  }
};
